/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';
import { ToolsService } from 'src/app/services/tools.service';
import { Location } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'app-chatbot',
  imports: [CommonModule, TranslateModule],
  standalone: true,
  templateUrl: './404.component.html',
  styleUrls: ['./404.component.scss'],
})
export class Error404Component {
    private location = inject(Location)
    private router = inject(Router);
    private tools = inject(ToolsService);
    private rest = inject(RestService);
    private navigation = inject(NavigationService);
    isAppLoaded = computed(() => this.tools.isAppLoaded());
    isLicenseExpired = computed(() => this.rest.expiredLicense())

    ngOnInit(){
        this.tools.enabledInstallBanner.update(prev => false);
        this.location.replaceState('');
    }

    goToLanding(){
        location.href = 'https://iurban.es';
    }

    goBack(){
        const currentUrl = this.router.url;
        if (currentUrl.includes('not-found'))
            this.navigation.resetNavigation();
    
        this.navigation.goBack();
    }
}